import styled from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding: 50px 5%;
`;

export const Cabecalho = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
`;

export const ConteudoDoCabecalho = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  padding: 0 30px;
  width: 95%;
  height: 40px;
`;

export const Divisor = styled.hr`
  width: 95%;
  margin: 10px 0;

  border: none;
  border-top: solid 1px ${(props) => props.theme.BACKGROUND};
`;

export const Titulo = styled.h3`
  position: absolute;

  width: 100%;

  text-align: center;
`;
